import type { SpacingConfig, BorderRadiusConfig, TextStyle } from '@/types/page';

/**
 * 将 SpacingConfig 转换为 React.CSSProperties
 * 用于应用动态边距样式
 */
export function getSpacingStyle(spacing?: SpacingConfig): React.CSSProperties {
  if (!spacing) return {};

  return {
    marginTop: spacing.marginTop,
    marginRight: spacing.marginRight,
    marginBottom: spacing.marginBottom,
    marginLeft: spacing.marginLeft,
    paddingTop: spacing.paddingTop,
    paddingRight: spacing.paddingRight,
    paddingBottom: spacing.paddingBottom,
    paddingLeft: spacing.paddingLeft,
  };
}

/**
 * 获取文本预设样式的 Tailwind 类名
 * 映射 TextStyle 枚举到对应的 CSS 类
 */
export function getTextPresetClasses(style: TextStyle): string {
  const PRESET_MAP: Record<TextStyle, string> = {
    TITLE_H1: 'text-2xl font-bold text-text-primary',
    TITLE_H2: 'text-xl font-bold text-text-primary',
    TITLE_H3: 'text-base font-bold text-text-primary',
    TEXT_LEFT: 'text-left text-text-primary',
    TEXT_CENTER: 'text-center text-text-primary',
    TEXT_RIGHT: 'text-right text-text-primary',
    QUOTE: 'border-l-4 border-primary bg-gray-100 p-3 italic text-text-secondary',
    BUTTON: 'inline-block px-3 py-1.5 bg-primary text-white rounded cursor-pointer hover:opacity-90 transition-opacity',
  };

  return PRESET_MAP[style] || '';
}

/**
 * 将 BorderRadiusConfig 转换为 React.CSSProperties
 * 用于应用动态圆角样式，默认 16px
 */
export function getBorderRadiusStyle(borderRadius?: BorderRadiusConfig): React.CSSProperties {
  if (!borderRadius) {
    // 默认 16px
    return { borderRadius: '16px' };
  }

  return {
    borderTopLeftRadius: borderRadius.topLeft || '16px',
    borderTopRightRadius: borderRadius.topRight || '16px',
    borderBottomRightRadius: borderRadius.bottomRight || '16px',
    borderBottomLeftRadius: borderRadius.bottomLeft || '16px',
  };
}
